import request from '@/utils/http.js';
// PS: prize/award的命名都表示奖品,历史原因与后端保持一致
// 获取奖品列表(发起端设置用)
const getPrizeList = params => {
  return request({
    url: '/v3/vss/lottery/post/get-prize-list',
    method: 'POST',
    data: {
      pos: 0,
      limit: 20,
      source: 0,
      ...params
    }
  });
};

// 获取当前抽奖状况
const checkLottery = params => {
  return request({
    url: '/v3/vss/lottery/check',
    method: 'GET',
    params
  });
};

// 发起抽奖
const pushLottery = params => {
  return request({
    url: '/v3/vss/lottery/add',
    method: 'POST',
    data: params
  });
};

// 获取可参与人数
const queryQualifiedPerson = params => {
  return request({
    url: '/v3/vss/lottery/search',
    method: 'GET',
    params: params
  });
};

// 更新在线用户
const updateUserStatus = params => {
  return request({
    url: '/v3/vss/lottery/update-user-status',
    method: 'GET',
    params: params
  });
};

// 结束抽奖
const endLottery = params => {
  return request({
    url: '/v3/vss/lottery/end',
    method: 'POST',
    params: params
  });
};

// 获取中奖人列表
const getWinnerList = params => {
  return request('/v3/vss/lottery/users-get', {
    method: 'POST',
    data: params
  });
};

// 检测是否已提交领奖信息
const checkLotteryResult = params => {
  return request('/v3/vss/lottery/award/check', {
    method: 'GET',
    params
  });
};

// 获取中奖页信息
const getDrawPrizeInfo = params => {
  return request('/v3/vss/lottery/watch/get-draw-prize-info', {
    method: 'POST',
    data: params
  });
};

// 提交中奖人信息
const acceptPrize = params => {
  return request('/v3/vss/lottery/award', {
    method: 'POST',
    data: params
  });
};

// 参与抽奖(口令)
const joinLottery = params => {
  return request('/v3/vss/lottery/participation', {
    method: 'POST',
    data: params
  });
};

// 获取抽奖历史
const getLotteryHistory = params => {
  return request('/v3/vss/lottery/check-list', {
    method: 'GET',
    params
  });
};
// 获取中奖人预填信息
const getLotteryUserInfo = params => {
  return request('/v3/vss/lottery/user-info', {
    method: 'POST',
    data: params
  });
};
// 查看中奖提交信息详情
const getLotteryUserDetail = params => {
  return request('/v3/vss/lottery/user-detail', {
    method: 'POST',
    data: params
  });
};

// v7.6.8抽奖优化添加接口

// 抽奖列表接口（列表、推送、复制、编辑、删除）
// 列表
const lotteryLiveList = params => {
  return request('/v3/vss/lottery/list', {
    method: 'POST',
    data: params
  });
};
// 复制
const lotteryLiveCope = params => {
  return request('/v3/vss/lottery/copy', {
    method: 'POST',
    data: params
  });
};
// 删除
const lotteryLiveDelete = params => {
  return request('/v3/vss/lottery/delete', {
    method: 'POST',
    data: params
  });
};
// 推送
const lotteryLivePublish = params => {
  return request('/v3/vss/lottery/publish', {
    method: 'POST',
    data: params
  });
};
// 结束抽奖
const lotteryLiveClose = params => {
  return request('/v3/vss/lottery/end-lottery', {
    method: 'POST',
    data: params
  });
};
// 获取中奖信息
const getLiveWinnerList = params => {
  return request('/v3/vss/console/lottery/winners/list', {
    method: 'POST',
    data: params
  });
}

// 条件与中奖用户设置
// 获取设置信息
const getConditionLiveInfo = params => {
  return request('/v3/vss/lottery/get-condition-user-setting', {
    method: 'POST',
    data: params
  });
};
// 保存设置信息
const saveConditionLiveInfo = params => {
  return request('/v3/vss/lottery/save-condition-user-setting', {
    method: 'POST',
    data: params
  });
};

// 创建、编辑奖品
const createLivePrize = params => {
  return request('/v3/vss/lottery/award/save', {
    method: 'POST',
    data: params
  });
};
// 奖品列表
const getLivePrizeList = params => {
  return request('/v3/vss/lottery/award/list', {
    method: 'POST',
    data: params
  });
};
// 删除奖品
const delLivePrize = params => {
  return request('/v3/vss/lottery/award/delete', {
    method: 'POST',
    data: params
  });
};
// 复制奖品
const copyLivePrize = params => {
  return request('/v3/vss/lottery/award/copy', {
    method: 'POST',
    data: params
  });
};
// 资料库奖品列表
const materialPrizeList = params => {
  return request('/v3/vss/lottery/post/get-prize-list', {
    method: 'POST',
    data: params
  });
};
// 抽奖 优惠券 列表
const lotteryCouponList = params => {
  return request('/v3/vss/lottery/award/coupon-list', {
    method: 'POST',
    data: params
  });
};
// 批量校验优惠券
const checkCoupons = params => {
  return request('/v3/goods/coupon-webinar/batch-check', {
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  });
};
// 优惠券信息
const getCouponInfo = params => {
  return request('/v3/goods/coupon/get-info', {
    method: 'GET',
    params
  });
};
// 抽奖优惠券信息
const getListCouponGoods = params => {
  return request('/v3/goods/coupon/get-goods-list', {
    method: 'GET',
    params
  });
};
// 奖品设置-资料库选择奖品保存按钮
const selectMateriaPrize = params => {
  return request('/v3/vss/lottery/award/copy-library', {
    method: 'POST',
    data: params
  });
};
// 奖品保存
const saveLivePrizeInfo = params => {
  return request('/v3/vss/lottery/save-award-setting', {
    method: 'POST',
    data: params
  });
};

// 领奖设置和抽奖设置接口
// 抽奖页-获取信息
const getLiveLotteryInfo = params => {
  return request('/v3/vss/lottery/get-base-info', {
    method: 'GET',
    params
  });
};
// 抽奖页-保存信息
const saveLiveLotteryInfo = params => {
  return request('/v3/vss/lottery/save-base-info', {
    method: 'POST',
    data: params
  });
};
// //领奖页-获取信息
const getLiveAwardInfo = params => {
  return request('/v3/vss/lottery/get-receive-award-setting', {
    method: 'POST',
    data: params
  });
};
// 领奖页-保存信息
const saveLiveAwardInfo = params => {
  return request('/v3/vss/lottery/save-receive-award-setting', {
    method: 'POST',
    data: params
  });
};

// 观众列表
const getAudienceList = params => {
  return request('/v3/webinars/audience/get-group-list', {
    method: 'POST',
    data: params
  });
};
// 检查观众组列表删除状态
const checkAudienceStatus = params => {
  return request('/v3/webinars/audience/check-group-del-status', {
    method: 'POST',
    data: params
  });
};
// 获取在线观众列表
const getOnlineUserList = params => {
  return request('/v3/interacts/chat-user/get-online-customer-list', {
    method: 'GET',
    params
  });
};
// 检查用户是否在线
const checkUserOnline = params => {
  return request('/v3/interacts/chat-user/check-user-online', {
    method: 'POST',
    data: params
  });
};
// 奖品列表
const getAwardList = params => {
  return request('/v3/vss/lottery/award/list', {
    method: 'POST',
    data: params
  });
};

// 查询用户是否满足参与抽奖条件
const checkPrecondition = params => {
  return request('/v3/vss/lottery/check-condition', {
    method: 'POST',
    data: params
  });
};


// 查询领奖配置信息
const getReceiveAwardSetting = params => {
  return request('/v3/vss/lottery/get-receive-award-setting', {
    method: 'POST',
    data: params
  });
};


export default {
  getPrizeList,
  pushLottery,
  queryQualifiedPerson,
  updateUserStatus,
  checkLottery,
  endLottery,
  getWinnerList,
  checkLotteryResult,
  getDrawPrizeInfo,
  acceptPrize,
  joinLottery,
  getLotteryHistory,
  getLotteryUserInfo,
  getLotteryUserDetail,
  // v7.6.8新增
  // 抽奖列表
  lotteryLiveList,
  lotteryLiveCope,
  lotteryLiveDelete,
  lotteryLivePublish,
  lotteryLiveClose,
  getLiveWinnerList,
  // 条件和用户设置
  getConditionLiveInfo,
  saveConditionLiveInfo,
  // 奖品设置
  createLivePrize,
  getLivePrizeList,
  // delPrize,
  // copyPrize,
  // getLivePrizeInfo,
  // savePrizeInfo,
  // getRewardInfo,
  // saveRewardInfo,
  // saveLotteryPrize,
  getAwardList,
  checkPrecondition,
  delLivePrize,
  copyLivePrize,
  materialPrizeList,
  lotteryCouponList,
  checkCoupons,
  getCouponInfo,
  getListCouponGoods,
  selectMateriaPrize,
  saveLivePrizeInfo,
  //  抽奖页设置
  getLiveLotteryInfo,
  saveLiveLotteryInfo,
  // 领奖页设置
  getLiveAwardInfo,
  saveLiveAwardInfo,
  getAudienceList,
  checkAudienceStatus,
  getReceiveAwardSetting,
  getOnlineUserList,
  checkUserOnline,
};
